import { render, staticRenderFns } from "./DocumentRetention.vue?vue&type=template&id=4259f86e&scoped=true&"
import script from "./DocumentRetention.vue?vue&type=script&lang=ts&"
export * from "./DocumentRetention.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentRetention.vue?vue&type=style&index=0&id=4259f86e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4259f86e",
  null
  
)

export default component.exports